import { Component, ViewChild } from "@angular/core";
import { Platform, Nav } from "ionic-angular";
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from "../pages/home/home";
import { ConnectorProvider } from "../providers/connector/connector";
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { environment } from '../providers/connector/environment';

import xml2js from 'xml2js';


export interface MenuItem {
    title: string;
    component: any;
    icon: string;
}

@Component({
    templateUrl: 'app.html'
})

export class MyApp {

    @ViewChild(Nav) nav: Nav;

    rootPage: any = HomePage;
    
    // Per LeftMenu
    logo: string
    toolbar_buttons: any


    constructor(
        public platform: Platform,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        public conn: ConnectorProvider,
        private iab: InAppBrowser,
    ) {
        this.initializeApp();
    }

    removingDuplicate(array) {
        return array.filter((elemento, indice) => array.indexOf(elemento) === indice);
    }

    initializeApp() {
        this.platform.ready().then(() => {
            // console.log("initializeApp");
            this.statusBar.styleDefault();
            this.statusBar.overlaysWebView(false);

            this.conn.getConfiguration().then(data => {
                //console.log("getConfiguration appComponents: ", data);
                let configuration: any = data;
                // Set values in connector
                this.conn.app_version = configuration.app_version
                this.conn.logo = environment.vhost_alias + configuration.logo
                //this.conn.toolbar_buttons = configuration.buttons
                this.conn.mapfilesdir = configuration.mapfilesdir
                this.conn.stations_mapfile = configuration.stations_mapfile
                this.conn.map_type = configuration.map_type
                this.conn.getfeature = configuration.getfeature
                this.conn.select_max_fcst = configuration.select_max_fcst
                this.conn.app_name = configuration.app_name
                // set local values 
                this.logo = this.conn.logo
                //this.toolbar_buttons = this.conn.toolbar_buttons
            });

            /***
             * Get List of variables/layers for the left menu
             */
            this.conn.getCatalogue().then(data => {
                this.parseCapabilities(data).then((data) => {
                    this.toolbar_buttons = [];
                    // Warning: forcing one layer on Torre Guaceto
                    // delete data['regions'][0]['variables'][1]['sub_var'][3]
                    // delete data['regions'][0]['variables'][1]['sub_var'][4]
                    let catalogue: any = data;
                    console.log("Left menu catalogue: ",catalogue);
                    let regions = catalogue.regions;
                    regions.forEach((region: any) => {
                        let variables = region.variables;
                        variables.forEach((element : any) => {
                            this.toolbar_buttons.push(element); 
                        });
                        this.toolbar_buttons[1]['sub_var'] = this.removingDuplicate(this.toolbar_buttons[1]['sub_var'])
                    }); 
                    //this.toolbar_buttons.sort((a,b)=> {
                        //return a.title.localeCompare(b.title);
                    //});
                    // console.log(this.toolbar_buttons)
                });
            });
        });
    }
    

    /** ****************************************************
     * 
     * Open external page (in-app browser)
     * @param url 
     * 
    ******************************************************* */
    openPage(url: string) {
        this.iab.create(url);
    }

    /** ****************************************************
     * Parse GetCapabilities response
     * @param xml
     ******************************************************* */
     parseCapabilities(data) {
        return new Promise(resolve => {
            // let _layers = []
            let parser = new xml2js.Parser({
                trim: true,
                explicitArray: true
            });

            parser.parseString(data, function (err, result) {

                // ****************  BEGIN: monoregion ******************************************
                let ret = {}

                // console.log('parseXML', result);
                let WMS_Capabilities = result.WMS_Capabilities;
                // console.log('parseXML', WMS_Capabilities);
                let Capability = WMS_Capabilities.Capability;
                // console.log('parseXML Capability', Capability);
                let MainLayer = Capability[0].Layer;
                // console.log('parseXML WMS_CMCC MainLayer ', MainLayer);

                ret['regions'] = []
                ret['regions'][0] = {
                    name: 'CASCADE',
                    bbox: '-43 11 43 73',
                    zoom: '4;6'
                };

                ret['regions'][0]['variables'] = []
                let _variables = MainLayer[0].Layer;
                let sub_variable_arr = [];
                

                // Arrange subvariables(gofs, medsea, satellite) inside variables(Meteo, observation)
                for (let j = 0; j < _variables.length; j++) {
                    let _variable = _variables[j]
                    let sub_variables = [];
                    if (_variable.Layer) {
                        for (let k = 0; k < _variable.Layer.length; k++) {
                            let _layer = _variable.Layer[k];
                            let sub_var = _layer.Name[0].split(":")[0];
                            if(!sub_variables.includes(sub_var))
                                sub_variables.push(convertString(sub_var)); 
                        }
                        sub_variable_arr[j] = sub_variables;
                        //sub_variable_arr[j].sort(function (a, b) {
                          //  return a.localeCompare(b);
                        //});
                    }
                }
            
                for (let j = 0; j < _variables.length; j++) {
                    let _variable = _variables[j];
                    ret['regions'][0]['variables'][j] = {
                        name: (_variable.Name[0]).replace(/_/g," "),
                        title: (_variable.Title[0]).replace(/_/g," "),
                        sub_var: sub_variable_arr[j],
                        expanded: false
                    }
                }

                //console.log('RET --> ', ret)
                resolve(ret);
                // ******************  END: monoregion ******************************************

            });
        });
    }


    /** OnVariable click */
    onLeftMenuChange(selected: any) { 
        this.conn.onMenuItemClick(selected);
        // console.log(selected);
    }

    /** Toggle expandable left menu */
    expandItem(variable): void {
        if (variable.expanded) {
            variable.expanded = false;
        } else {
            this.toolbar_buttons.map(listItem => {
            if (variable == listItem) {
              listItem.expanded = !listItem.expanded;
            } else {
              listItem.expanded = false;
            }
            return listItem;
          });
        }
      }

}

function capitalizeString(name: string){
    let capitalizedName = name.toLowerCase();
    return name.charAt(0).toUpperCase() + capitalizedName.slice(1);
}

function convertString(name: String){
    return name.replace(/_/g,": ").replace(/-/g," ")
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts